import { toast } from "react-toastify";

const initState = {
    isLoading: false,
    error: false,
    news: null,
    isGameOn: false,
    didGameEnded: false,
    gameTime: 0,
    gameStart: 0,
    randomNumber: 1,
    rounds: 10,
    currentRound: 0,
    skips: 3,
    rewards: {
        exp: null,
        score: null,
        items: null
    }
}

function converToMinutes(millis) {
    let minutes = Math.floor(millis / 60000);
    return minutes;
}

const studygameReducer = (state = initState, action) => {
    switch (action.type) {
        case 'IS_LOADING':
            return {
                ...state,
                isLoading: true
            }
        case 'START_STUDY_GAME_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isGameOn: true,
                gameTime: 0,
                currentRound: 1,
                gameStart: Date.now(),
                news: action.payload
            }
        case 'START_STUDY_GAME_ERROR':
            toast.error(`Ops, aconteceu um erro e não foi possível começar uma partida...`)
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case 'STUDY_GAME_ROUND_COMPLETED':
            let finishTime = Date.now()
            let calculateGameTime = finishTime - state.gameStart
            let convertGameTime = converToMinutes(calculateGameTime)

            return {
                ...state,
                isLoading: false,
                gameTime: convertGameTime,
                currentRound: action.payload,
                skips: action.skips
            }
        case 'STUDY_GAME_COMPLETED_SUCCESS':
            toast.success(`Partida de Mundo em Notícias concluida, parabéns!`)

            return {
                ...state,
                gameStart: 0,
                didGameEnded: true,
                isGameOn: false,
                currentRound: 0,
                isLoading: false,
                rewards: {
                    exp: action.payload.exp,
                    score: action.payload.score,
                    items: action.payload.items
                }
            }
        case 'STUDY_GAME_COMPLETED_ERROR':
            toast.error(`Ops, aconteceu um erro e não foi possível terminar a partida!`)

            return {
                ...state,
                gameStart: 0,
                didGameEnded: true,
                isGameOn: false,
                currentRound: 0,
                isLoading: false
            }
        case 'QUIT_GAME':
            return {
                ...initState
            }
        default:
            return state
    }
}

export default studygameReducer